import { render, staticRenderFns } from "./PlanStatusNote.vue?vue&type=template&id=3cde6708&scoped=true"
import script from "./PlanStatusNote.vue?vue&type=script&lang=js"
export * from "./PlanStatusNote.vue?vue&type=script&lang=js"
import style0 from "./PlanStatusNote.vue?vue&type=style&index=0&id=3cde6708&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cde6708",
  null
  
)

export default component.exports